import { Component, computed, effect, input, output } from "@angular/core";
import { MonitoringCategory } from "@domain/product/monitoring/monitoring-product.service";
import { ProductImage } from "@domain/product/product-image";
import { DisplayConfiguration } from "@domain/project/configurations/monitoring/display-configuration";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { FloorplanSidesheetExtent } from "@domain/project/floorplan/floorplan-sidesheet-extent";
import { FloorplanDisplay } from "@domain/project/floorplan/monitoring/floorplan-display";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";
import { FloorplanCustomPartNumbersComponent } from "@project/floorplanner/floorplan-custom-part-numbers/floorplan-custom-part-numbers.component";
import { FloorplanItemAttachmentsButtonComponent } from "@project/floorplanner/floorplan-item-attachments-button/floorplan-item-attachments-button.component";
import { FloorplanItemGroupComponent } from "@project/floorplanner/floorplan-item-group/floorplan-item-group.component";
import { MonitoringProductItem } from "@project/monitoring-product-item";
import {
  buildDisplayGroupedSourceItems,
  DisplayGroupedPartLabels,
} from "@project/monitoring/grouped-parts/monitoring-grouped-parts-source-item.factory";
import {
  getDisplayGroupedPartLabels,
  getMonitoringConfigurationSummaryTitle,
} from "@project/monitoring/grouped-parts/monitoring-grouped-parts.helper";
import { MonitoringGroupedPartSourceItem } from "@project/monitoring/grouped-parts/monitoring-grouped-parts.types";

@Component({
  selector: "app-display-notes",
  imports: [
    FloorplanItemDetailsComponent,
    FloorplanItemGroupComponent,
    FloorplanItemAttachmentsButtonComponent,
    FloorplanCustomPartNumbersComponent,
  ],
  templateUrl: "./display-notes.component.html",
  styleUrl: "./display-notes.component.scss",
  standalone: true,
})
export class DisplayNotesComponent {
  readonly floorplanItem = input.required<FloorplanItem>();
  readonly extent = input.required<FloorplanSidesheetExtent>();
  readonly toggleExtendedButtonClicked = output<void>();
  protected readonly display = computed(() => this.floorplanItem() as FloorplanDisplay);
  protected readonly MonitoringCategory = MonitoringCategory;
  protected readonly SidesheetExtent = FloorplanSidesheetExtent;

  protected productItems!: MonitoringProductItem[];
  protected monitoringItems: MonitoringGroupedPartSourceItem[] = [];
  protected imageUrl = "./assets/floorplan-menu-icons/display_menu.svg";
  protected monitoringTitle = getMonitoringConfigurationSummaryTitle(MonitoringCategory.DISPLAYS);
  private readonly categoryLabels: DisplayGroupedPartLabels = getDisplayGroupedPartLabels();

  constructor() {
    effect(() => {
      const display = this.display();
      const productImageUrl = ProductImage.getCantoSourceUrl(display.config.display.option.groupImageCantoID ?? "");
      if (productImageUrl) {
        this.imageUrl = productImageUrl;
      }
      this.productItems = display.config.getOptions();
      this.monitoringItems = this.buildMonitoringItems(display.config);
    });
  }

  private buildMonitoringItems(config: DisplayConfiguration): MonitoringGroupedPartSourceItem[] {
    return buildDisplayGroupedSourceItems(
      {
        display: config.display,
        accessories: config.accessories,
      },
      this.categoryLabels,
    );
  }
}
